import React, { Component } from 'react'
import { Button, Col, Row, Form, Input, message } from 'antd'
// import AuthContext from '../../hooks/AuthContext';
import { getVerificationCode, getLogin } from '../../service'
import { UserOutlined, SafetyCertificateOutlined } from '@ant-design/icons'
import { withRouter } from 'react-router-dom'
import { originalPath } from '../../utils/tools'
// import { checkCookie } from '../../utils/cookie';
import 'antd/dist/antd.css'
import './login.less'
import { FormInstance } from 'antd/lib/form'
class LoginPage extends Component<any, any> {
  // static contextType = AuthContext;
  constructor (...args: any) {
    // @ts-ignore
    super(...args)
    const { location = {} } = this.props
    console.log('LoginPage constructor:', this.props)
    const { from } = location.state || { from: { pathname: '/' } }
    this.state = {
      pageFrom: from,
      // responseId: 0,
      phoneNum: '',
      verficationNum: '',
      leftSeconds: -1,
      loginButtonDisabled: false,
      cookie: 'token'
    }
  }

    formRef = React.createRef<FormInstance>();
    // 获取验证码
    getVerification = () => {
      getVerificationCode({
        phone: this.state.phoneNum
      })
        .then((res: any) => {
          if (res.status === '200') {
            message.success('验证码已发送，请注意查收')
            this.setState({ leftSeconds: 59 })
            const timer = setInterval(() => {
              if (this.state.leftSeconds <= 0) {
                clearInterval(timer)
                this.setState({ leftSeconds: -1 })
                return
              }
              this.setState((prev: any) => ({ leftSeconds: prev.leftSeconds - 1 }))
            }, 1000)
            localStorage.setItem('responseId', res.data.reponse_id)
          } else {
            this.setState({ leftSeconds: -1 })
            message.error(res.msg)
          }
        })
        .catch(() => {
          this.setState({ leftSeconds: -1 })
        })
    };

    // 提交表单
    onFinish = (value: any) => {
      const formData = new FormData()
      formData.append('username', value.username)
      formData.append('password', value.password)
      this.setState({ responseId: localStorage.getItem('responseId') })
      formData.append('response_id', this.state.responseId)
      getLogin(formData).then((res: any) => {
        if (res.status === '200') {
          const location = originalPath()
          window.location.href = location + '/webapp/main/admin'
          message.success('登录成功')
        } else {
          message.error(res.msg)
        }
      }).catch((err: any) => {
        console.log(err)
      })
    };

    // 手机号验证
    handlePhoneNum = (value: string) => {
      this.setState({
        phoneNum: value
      })
      this.validateForm()
    };

    validateForm = () => {
      this.formRef.current
        ?.validateFields()
        .then(() => this.setState({ loginButtonDisabled: false }))
        .catch(() => this.setState({ loginButtonDisabled: true }))
    };

    // 密码回填
    handlePasswordChange = (value: string) => {
      this.setState({
        verficationNum: value
      })
      this.validateForm()
    };

    onFinishFailed = () => {
      console.log('Failed:')
    };

    render (): any {
      console.log('LoginPage render')
      return (
            <div className="container">
                <div className="box">
                    <Row>
                        <Col span={12}>
                            <div className="imgBox">
                                <img
                                    src="http://pages.anjukestatic.com/usersite/pc/anjuhao/defaultLogin.png"
                                    alt=""
                                />
                            </div>
                        </Col>
                        <Col span={12}>
                            <div className="loginBox">
                                <div className="title">OPENCMS</div>
                                <Form
                                    name="basic"
                                    ref={this.formRef}
                                    onFinish={this.onFinish}
                                    onFinishFailed={this.onFinishFailed}
                                >
                                    <Form.Item
                                        className="username"
                                        name="username"
                                        rules={[
                                          {
                                            required: true,
                                            message: '请填写手机号！'
                                          },
                                          () => ({
                                            validator (_, value) {
                                              const reg = /^1[0|2|3|4|5|6|7|8|9][0-9]{9}$/
                                              // let reg= /^((13[0-9])|(14[5-9])|(15([0-3]|[5-9]))|(16[6-7])|(17[1-8])|(18[0-9])|(19[1|3])|(19[5|6])|(19[8|9]))\d{8}$/
                                              if (!value || reg.test(value)) {
                                                return Promise.resolve()
                                              }
                                              return Promise.reject(new Error('手机号格式不对，请重新输入'))
                                            }
                                          })
                                        ]}
                                    >
                                        <Input
                                            className="inputstyle"
                                            value={this.state.phoneNum}
                                            onChange={(e) => {
                                              this.handlePhoneNum(e.target.value)
                                            }}
                                            prefix={
                                                <UserOutlined className="site-form-item-icon" />
                                            }
                                            placeholder="请输入手机号码"
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        className="password"
                                        name="password"
                                        rules={[
                                          {
                                            required: true,
                                            message: '请输入验证码！'
                                          },
                                          {
                                            pattern: /^[0-9]{6}$/,
                                            message: '请输入6位验证码'
                                          }
                                        ]}
                                    >
                                        <Input
                                            className="inputstyle verficationCode"
                                            autoComplete="off"
                                            prefix={
                                                <SafetyCertificateOutlined className="site-form-item-icon" />
                                            }
                                            onChange={(e) => {
                                              this.handlePasswordChange(e.target.value)
                                            }}
                                            maxLength={6}
                                            value={this.state.verficationNum} placeholder="请输入手机动态码"
                                        />
                                    </Form.Item>
                                    <Button
                                        type="text"
                                        className="verficationNum"
                                        disabled={
                                            this.state.phoneNum.length !== 11 ||
                                            (this.state.leftSeconds > 0 && this.state.leftSeconds)
                                        }
                                        onClick={this.getVerification}
                                    >获取验证码
                                        {this.state.leftSeconds > 0 && this.state.leftSeconds }
                                    </Button>

                                    <Form.Item>
                                        <Button
                                            color="green"
                                            disabled={
                                                !this.state.phoneNum ||
                                                !this.state.verficationNum ||
                                                this.state.loginButtonDisabled
                                            }
                                            htmlType="submit"
                                            className="login-form-button"
                                        >
                                            登录
                                        </Button>
                                    </Form.Item>
                                    <Form.Item></Form.Item>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
      )
    }
}
export default withRouter(LoginPage)
